import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class OptionButton extends PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {
      onClick,
      option,
    } = this.props;
    onClick(option);
  }

  render() {
    const {
      className,
      children,
      disabled,
      tabIndex,
    } = this.props;


    return (
      <button
        type="button"
        className={className}
        onClick={this.handleClick}
        disabled={disabled}
        tabIndex={tabIndex}
      >
        {children}
      </button>
    );
  }
}

OptionButton.propTypes = {
  className: PropTypes.string,
  // option needs to be any as it can be any shape of paramators for a callbacks
  /* eslint-disable-next-line react/forbid-prop-types */
  option: PropTypes.any,
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
};

OptionButton.defaultProps = {
  tabIndex: '0',
};

export { OptionButton };
